import type { ReactNode } from "react"

import { cx } from "../lib/cx"
import styles from "./counter.module.css"

/**
 * Счётчик.
 *
 * ЧИСЛО БЕЗ СЛОВА НЕ ЗНАЧИТ НИЧЕГО. «3» на колокольчике глазами читается мгновенно,
 * а голосом — как «три» посреди названия кнопки. Поэтому подпись обязательна:
 * на экране видно число, программе чтения достаётся «3 непрочитанных уведомления».
 *
 * ТОН — НЕ УКРАШЕНИЕ. «attention» значит «требует действия человека» (непрочитанные
 * уведомления, записи без подтверждения), «quiet» — «просто количество» (сколько
 * визитов на вкладке). Тон выбирается по смыслу, а не по тому, где ярче смотрится.
 */

export type CounterTone = "attention" | "quiet" | "on-nav"

const TONE_STYLE: Readonly<Record<CounterTone, string | undefined>> = {
  attention: styles.attention,
  quiet: styles.quiet,
  "on-nav": styles.onNav,
}

export function Counter(props: {
  readonly value: number
  /** Чего именно столько: «непрочитанных уведомления», «визита». */
  readonly label: string
  readonly tone?: CounterTone
  /** Поставить в правый верхний угол кнопки-значка (колокольчик в шапке). */
  readonly corner?: boolean
  readonly className?: string | undefined
}): ReactNode {
  const { tone = "quiet", corner = false } = props
  return (
    <span
      className={cx(styles.counter, TONE_STYLE[tone], corner ? styles.corner : undefined, props.className)}
    >
      <span aria-hidden="true">{props.value}</span>
      <span className="plnr-visually-hidden">
        {props.value} {props.label}
      </span>
    </span>
  )
}
